<template>
  <div
    class="border-2 p-4 rounded-md flex flex-col md:flex-row md:items-center justify-between gap-6 mx-1 mb-4"
  >
    <h5>{{ title }}</h5>
    <div class="flex flex-col md:flex-row gap-6">
      <span class="w-44 flex flex-row items-center gap-2">
        <v-icon name="fa-chevron-circle-right" class="text-h-primary-500" />
        <h6>{{ "Envio" }}</h6>
        <span class="px-3 py-2 rounded-md bg-h-primary-100 text-h-primary-500">
          {{ sents }}</span
        >
      </span>
      <span class="w-48 flex flex-row items-center gap-2 md:mr-12 sm:mr-6">
        <v-icon name="fa-check-circle" class="text-h-success-500" />
        <h6>{{ "Corrigidos" }}</h6>
        <span
          class="px-3 py-2 rounded-md bg-h-success-100 text-h-success-500 w-auto"
        >
          {{ correcteds }}</span
        >
      </span>
      <Button
        class="btn-outline"
        :label="
          $t('labels.generic', { en: 'See Activity', pt: 'Ver Atividade' })
        "
        @click.prevent="goTo"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    activityId: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    students: {
      type: Number,
      default: 0,
    },
    completed: {
      type: Number,
      default: 0,
    },
    feedback: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    sents(): string {
      return `${this.$props?.completed} / ${this.$props?.students}`;
    },
    correcteds(): string {
      return `${this.$props?.feedback} / ${this.$props?.students}`;
    },
  },
  methods: {
    goTo() {
      this.$emit("onGoTo", this.$props?.activityId);
    },
  },
});
</script>
